<script lang="ts">
  import { ConfigStore } from '../store/config';
  import { _ } from 'svelte-i18n';
  import { CsatRatingTypes } from '../enums/csat-rating.enum';
  import RatingCsatVersionOne from './rating-csat-options/rating-csat-version-one.svelte';
  import { state_conversationResults } from '../store/state';
  import { WindowsCustomEventTypes } from '../enums/windows-custom-event.enum';
  import SvgIcon from './svg-icon.svelte';

  export let questionId: string;

  const closeRating = () => {
    window.dispatchEvent(
      new CustomEvent(WindowsCustomEventTypes.showCsatPopup, {
        detail: {
          isRated: true,
          isNotification: false,
          lengthOfQuestions: $state_conversationResults.length,
        },
      })
    );
  };
</script>

<button
  on:click={closeRating}
  class="cs-rating-csat__close"
  aria-label={$_('csat.close')}><SvgIcon name="x" /></button
>
<h3
  class="cs-rating-csat__title"
  tabindex="0"
  aria-label={$ConfigStore.csatTitleQuestion || $_('csat.title_question')}
  title={$ConfigStore.csatTitleQuestion || $_('csat.title_question')}
>
  {@html $ConfigStore.csatTitleQuestion || $_('csat.title_question')}
</h3>
<RatingCsatVersionOne {questionId} />

<style lang="scss">
  @use '../../scss/components/_rating-csat';
</style>
